import { NotificationTemplatesResponseModel } from "../pages/shared/models/api/notificaiotn-templates-response.model";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getMyNotifications(
  filter: object = {},
  page?: number,
  limit?: number,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const queryParams: { [key: string]: any } = {};

    if (page) {
      queryParams["page"] = page;
    }
    if (limit) {
      queryParams["limit"] = limit;
    }

    const sorting = { sendDate: -1 };

    return axiosInstance
      .post(
        `${API_URL}/user-notifications/my`,
        {
          filter: filter,
          sorting: sorting,
        },
        { params: { ...queryParams }, ...authorizationHeader },
      )
      .then((response) => response?.data as NotificationTemplatesResponseModel);
  } catch (error) {
    console.error(error);
  }
}

async function getNotificationById(userNotificationId: number | undefined) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .get(
        `${API_URL}/user-notifications/${userNotificationId}`,
        authorizationHeader,
      )
      .then((response) => response?.data as NotificationTemplatesResponseModel);
  } catch (error) {
    console.error(error);
  }
}

async function updateNotificationsById(
  userNotificationId: number[] | undefined,
  data: object,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/user-notifications/update`,
        {
          userNotificationIds: userNotificationId,
          data,
        },
        authorizationHeader,
      )
      .then((response) => response?.data as NotificationUpdateMeta);
  } catch (error) {
    console.error(error);
  }
}

async function getNotificationsCount(includeUnread: boolean) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .get(
        `${API_URL}/user-notifications/my/count?includeUnread=${includeUnread}`,
        authorizationHeader,
      )
      .then((response) => response?.data);
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getMyNotifications,
  getNotificationById,
  getNotificationsCount,
  updateNotificationsById,
};

export interface NotificationUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}
